module.exports = __webpack_public_path__ + "img/cardiovascular.e850c225.png";